import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_SUPPLIER } from '../bauprofi.api';
import { Supplier } from '@softapps/wws/core';

export interface BauprofiSupplierQuery {
  id: string | undefined;
}

@Injectable()
export class BauprofiSupplierRepository extends ReadonlyHttpApiRepository<
  Result<Supplier>,
  BauprofiSupplierQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_SUPPLIER);
  }

  override getLoadPathParams(params: BauprofiSupplierQuery): Dictionary<unknown> {
    return {
      id: params.id,
    };
  }
}
